export const PLAYER_SIZE__SMALL = 1;
export const PLAYER_SIZE__BIG = 2;
